import request from '@/router/axios'
import env from '@/config/env'
import { pickBy } from 'lodash-es'
import qs from 'qs'
import globalVariable from '@/config/globalVariable'

const { TIME } = globalVariable

/**
 * 查询供应商公司（供应商及其下属供应商）
 */
export const getAllLowMerchant = () => {
  return request({
    url: env.ferryUrl + '/merchantPriceAdmin/getAllLowMerchant',
    method: 'GET',
    timeout: TIME
  })
}

/**
 * 根据供应商获取车牌
 * @param spendingCompanyId
 */
export const getCar = (spendingCompanyId) => {
  return request({
    url: env.ferryUrl + `/settle-ticket-rule/car/${spendingCompanyId}`,
    method: 'GET',
    timeout: TIME
  })
}

/**
 * 获取线路名称
 * @param id
 */
export const queryAllLowLine = (id) => {
  return request({
    url: env.ferryUrl + `/lineAdmin/getLineByMerchantIds?merchantId=${id}`,
    method: 'GET',
    timeout: TIME
  })
}

/**
 * 获取营收账单分页
 * @param data
 */
export const revenueBillPage = (data) => {
  return request({
    url: env.ferryUrl + '/revenue-bill/page',
    method: 'POST',
    timeout: TIME,
    data: data
  })
}

// /**
//  * 新增结算单
//  * @param data
//  */
// export const saveStatementsCreate = (data) => {
//   return request({
//     url: env.ferryUrl + '/statements/create',
//     method: 'POST',
//     data: data
//   })
// }

/**
 * 获取营收账单详情
 * @param data
 */
export const revenueBillDetails = (id) => {
  return request({
    url: env.ferryUrl + `/revenue-bill/info/${id}`,
    method: 'POST',
    timeout: TIME
  })
}
/**
 * 导出结算明细
 * @param data
 */
// export const exportDetails = (data) => {
//   return request({
//     url: env.ferryUrl + '/settle/export/details',
//     method: 'GET',
//     data:data
//   })
// }

/**
 * 导出结算明细
 * @param data
 */
export const exportDetails = (queryParam) => {
  let url = env.importExcelUrl + env.ferryUrl + `/settle/export/details`
  let parma = pickBy({ ...queryParam })
  url = url + '?' + qs.stringify(parma)
  return (window.location.href = url)
}

/**
 * 确认记录上传附件
 * @param param
 */
export const revenueBillConfirm = (param) => {
  return request({
    url: env.ferryUrl + '/revenue-bill/confirm',
    method: 'POST',
    timeout: TIME,
    data: param
  })
}
